import { __decorate } from "tslib";
import "element-internals-polyfill";
import { css, html, LitElement } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { styleMap } from "lit/directives/style-map.js";
//2.
const MAX_MATCHES = 15;
let TypeaheadEditorElement = class TypeaheadEditorElement extends LitElement {
    get liveValue() {
        var _a;
        return (_a = this._inputElement) === null || _a === void 0 ? void 0 : _a.value;
    }
    constructor() {
        super();
        this.required = false;
        this.disabled = false;
        this.showAll = false;
        this._opened = false;
        this._matches = [];
        this.maxSuggestions = MAX_MATCHES;
        this._handleResize = () => this.onResize();
    }
    disable(isDisable = true) {
        this.disabled = isDisable;
    }
    valueChanged() {
        this.dispatchEvent(new CustomEvent("valueChanged", {
            bubbles: true,
            composed: true,
            detail: { editor: this, value: this.liveValue, oldValue: this.value },
        }));
    }
    async updateValue() {
        var _a;
        if ((_a = this.textOptions) === null || _a === void 0 ? void 0 : _a.length) {
            if (!this._inputElement.value) {
                if (!this.showAll)
                    this.close();
            }
            else {
                if (!this._opened) {
                    this.open();
                }
                else {
                    this._matches = this.showAll ? this.textOptions : this.getSuggestions();
                    this._suggestionElement.style.top = "0px";
                    this._suggestionElement.style.left = "0px";
                    this.requestUpdate();
                    await this.updateComplete;
                    this.onResize();
                }
            }
        }
        this._setHighlightedElement();
        if (this._inputElement.checkValidity())
            this._inputElement.classList.remove("invalid");
        else
            this._inputElement.classList.add("invalid");
        this.dispatchEvent(new CustomEvent("editorChanged", { bubbles: true, composed: true, detail: { editor: this } }));
    }
    async reportValidity() {
        if (this._inputElement.reportValidity()) {
            this._inputElement.classList.remove("invalid");
            return true;
        }
        else {
            this._inputElement.classList.add("invalid");
            return false;
        }
    }
    setCustomValidity(error) {
        this._inputElement.setCustomValidity(error);
    }
    clearCustomValidity() {
        this._inputElement.classList.remove("invalid");
    }
    async firstUpdated() { }
    cancel() {
        this._inputElement.classList.remove("invalid");
        this._inputElement.value = this.value;
    }
    _onKeyDown(ev) {
        if (ev.key === "ArrowUp" || ev.key === "ArrowDown") {
            ev.preventDefault();
            ev.stopPropagation();
        }
        else if (ev.key === "Tab") {
            if (this._opened) {
                ev.preventDefault();
                ev.stopPropagation();
                this._highlightedElement && this._highlightedElement.dispatchEvent(new MouseEvent("mousedown"));
            }
        }
    }
    async _onKeyUp(ev) {
        switch (ev.key) {
            case "ArrowUp":
                ev.preventDefault();
                ev.stopPropagation();
                this._markPreviousElement();
                break;
            case "ArrowDown":
                ev.preventDefault();
                ev.stopPropagation();
                this._markNextElement();
                break;
            case "Enter":
                this._highlightedElement && this._highlightedElement.dispatchEvent(new MouseEvent("mousedown"));
                this.blur();
                break;
            case "Escape":
                this.close();
                this.blur();
                break;
        }
    }
    _markPreviousElement() {
        if (!this._highlightedElement || !this._highlightedElement.previousElementSibling) {
            if (!this._highlightedElement &&
                this._suggestionElement.lastElementChild &&
                this._suggestionElement.lastElementChild instanceof HTMLLIElement) {
                this._highlightedElement = this._suggestionElement.lastElementChild;
                this._highlightedElement.classList.add("active");
                this._highlightedElement.scrollIntoView();
            }
            return;
        }
        this._highlightedElement.classList.remove("active");
        if (this._highlightedElement.previousElementSibling instanceof HTMLLIElement) {
            this._highlightedElement = this._highlightedElement.previousElementSibling;
            this._highlightedElement.classList.add("active");
            this._highlightedElement.scrollIntoView();
        }
    }
    _markNextElement() {
        if (!this._highlightedElement || !this._highlightedElement.nextElementSibling) {
            if (!this._highlightedElement &&
                this._suggestionElement.firstElementChild &&
                this._suggestionElement.firstElementChild instanceof HTMLLIElement) {
                this._highlightedElement = this._suggestionElement.firstElementChild;
                this._highlightedElement.classList.add("active");
                this._highlightedElement.scrollIntoView();
            }
            return;
        }
        this._highlightedElement.classList.remove("active");
        if (this._highlightedElement.nextElementSibling instanceof HTMLLIElement) {
            this._highlightedElement = this._highlightedElement.nextElementSibling;
            this._highlightedElement.classList.add("active");
            this._highlightedElement.scrollIntoView();
        }
    }
    async _onFocusAsync(ev) {
        var _a;
        this._blur = false;
        if (!this.textOptions) {
            this.textOptions = await this.getTextOptions();
        }
        if (((_a = this.textOptions) === null || _a === void 0 ? void 0 : _a.length) && !this._opened) {
            this.open();
            //this.suggest(this.getSuggestions(), true);
            //this.suggest(this.textOptions, true);
        }
    }
    _onBlur(ev) {
        this.close();
        //this._blur = true;
        //!this._mouseEnter && this.close();
    }
    _handleItemMouseEnter(ev) {
        //this._mouseEnter = true;
    }
    _handleItemMouseLeave(ev) {
        //this._mouseEnter = false;
        //this._blur && setTimeout(_ => this.close(), 500);
    }
    _setHighlightedElement() {
        if (this._highlightedElement) {
            this._highlightedElement.classList.remove("active");
            this._highlightedElement = null;
        }
        if (this.showAll) {
            const value = this.liveValue;
            if (value) {
                for (const item of Array.from(this._suggestionElement.children)) {
                    if (item instanceof HTMLLIElement) {
                        //check for exact match first
                        if (item.textContent.toLowerCase() === value.toLowerCase()) {
                            this._highlightedElement = item;
                            break;
                        }
                        if (!this._highlightedElement) {
                            if (item.textContent.toLowerCase().indexOf(value.toLowerCase()) > -1) {
                                this._highlightedElement = item;
                            }
                        }
                    }
                }
            }
            if (this._highlightedElement) {
                this._highlightedElement.classList.add("active");
                this._highlightedElement.scrollIntoView();
            }
        }
        else {
            if (this._suggestionElement.children[0] instanceof HTMLLIElement) {
                this._highlightedElement = this._suggestionElement.children[0];
                if (this._highlightedElement)
                    this._highlightedElement.classList.add("active");
            }
        }
    }
    async open() {
        var _a;
        if ((_a = this.textOptions) === null || _a === void 0 ? void 0 : _a.length) {
            this._matches = this.showAll ? this.textOptions : this.getSuggestions();
            this._suggestionElement.style.top = "0px";
            this._suggestionElement.style.left = "0px";
            this._opened = true;
            await this.updateComplete;
            this.onResize();
            for (const item of Array.from(this._suggestionElement.children)) {
                item.classList.remove("active");
            }
            this._setHighlightedElement();
        }
    }
    async close() {
        this._opened = false;
        await this.updateComplete;
        if (this._highlightedElement)
            this._highlightedElement.classList.remove("active");
        this._highlightedElement = null;
    }
    autocomplete(value) {
        this._inputElement.value = value;
        this.updateValue();
        this.valueChanged();
        this.close();
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("resize", this._handleResize);
    }
    disconnectedCallback() {
        window.removeEventListener("resize", this._handleResize);
        super.disconnectedCallback();
    }
    onResize() {
        const contentRec = this._inputElement.getBoundingClientRect();
        this._suggestionElement.style.width = contentRec.width - 2 + "px"; //This can make the suggestion box higher because of text wrapping, so must come before next line.
        const seggestRec = this._suggestionElement.getBoundingClientRect();
        this._suggestionElement.style.left = contentRec.left + "px";
        if (contentRec.bottom + seggestRec.height < window.innerHeight) {
            this._suggestionElement.style.top = contentRec.bottom + "px";
            this._suggestionElement.classList.remove("position-top");
            this._suggestionElement.classList.add("position-bottom");
        }
        else {
            this._suggestionElement.style.top = contentRec.top - seggestRec.height + "px";
            this._suggestionElement.classList.remove("position-bottom");
            this._suggestionElement.classList.add("position-top");
        }
    }
    highlightChars(item) {
        const value = this.liveValue;
        if (value) {
            const index = value.length > 0 ? item.toLowerCase().indexOf(value.toLowerCase()) : -1;
            if (index > -1) {
                return html `${item.substring(0, index)}<b>${item.substring(index, index + value.length)}</b>${item.substring(index + value.length)}`;
            }
        }
        return item;
    }
    getSuggestions() {
        const value = this.liveValue;
        if (this.textOptions && value) {
            const suggestions = this.textOptions.filter((item) => item
                .replace(",", "")
                .replace(/\s/g, "")
                .toLowerCase()
                .search(value.replace(",", "").replace(/\s/g, "").toLowerCase()) !== -1);
            return suggestions;
        }
        else {
            return [];
        }
    }
    render() {
        const font = { font: this.editorSize === "small" ? "var(--font-input-small)" : "var(--font-input)" };
        return html `
            <div>
                <input
                    id="input"
                    name="${this.name}"
                    style="${styleMap({ ...font, width: this.inputWidth })}"
                    .value="${this.value}"
                    @input="${this.updateValue}"
                    @change="${this.valueChanged}"
                    min="${ifDefined(this.min)}"
                    max="${ifDefined(this.max)}"
                    maxlength="${ifDefined(this.maxlength)}"
                    minlength="${ifDefined(this.minlength)}"
                    size="${ifDefined(this.size)}"
                    pattern="${ifDefined(this.pattern)}"
                    placeholder="${ifDefined(this.placeholder)}"
                    ?required="${this.required}"
                    ?disabled="${this.disabled}"
                    @focus=${this._onFocusAsync}
                    @blur=${this._onBlur}
                    @keydown=${this._onKeyDown}
                    @keyup=${this._onKeyUp}
                    spellcheck="false"
                />
            </div>
            <ul
                ?hidden=${!this._opened}
                id="suggestions"
                @mouseenter=${this._handleItemMouseEnter}
                @mouseleave=${this._handleItemMouseLeave}
            >
                ${this._matches.map((item) => html `<li @mousedown=${(ev) => this.autocomplete(item)}>${this.highlightChars(item)}</li>`)}
            </ul>
        `;
    }
};
TypeaheadEditorElement.styles = css `
        :host {
            display: block;
            box-sizing: border-box;
        }
        :host([hidden]) {
            display: none;
        }

        input.invalid {
            outline: 2px solid pink;
        }
        .wrapper {
            position: relative;
        }
        ul {
            position: absolute;
            left: 0;
            top: 0;
            margin: 0;
            padding: 0;
            z-index: 5000;
            background: white;
            display: block;
            list-style-type: none;
            border-left: 1px solid grey;
            box-shadow: grey 1px 1px 1px;
            border-radius: 2px;
            max-height: 300px;
            overflow: auto;
        }

        ul.position-bottom {
        }

        ul.position-top {
            border-top: 1px solid grey;
        }

        li {
            padding: 6px;
            cursor: pointer;
        }

        li:hover {
            outline: 1px solid var(--color-secondary);
            outline-offset: -2px;
            border-radius: 3px;
        }
        li.active {
            color: white;
            background-color: var(--color-secondary);
        }

        [hidden] {
            display: none;
        }
        #input {
            box-sizing: border-box;
        }
    `;
__decorate([
    property()
], TypeaheadEditorElement.prototype, "value", void 0);
__decorate([
    property({ attribute: false, type: Array })
], TypeaheadEditorElement.prototype, "textOptions", void 0);
__decorate([
    property({ attribute: false })
], TypeaheadEditorElement.prototype, "getTextOptions", void 0);
__decorate([
    property({ type: Number })
], TypeaheadEditorElement.prototype, "size", void 0);
__decorate([
    property({ type: Number })
], TypeaheadEditorElement.prototype, "minlength", void 0);
__decorate([
    property({ type: Number })
], TypeaheadEditorElement.prototype, "maxlength", void 0);
__decorate([
    property()
], TypeaheadEditorElement.prototype, "width", void 0);
__decorate([
    property({ attribute: "input-width" })
], TypeaheadEditorElement.prototype, "inputWidth", void 0);
__decorate([
    property()
], TypeaheadEditorElement.prototype, "min", void 0);
__decorate([
    property()
], TypeaheadEditorElement.prototype, "max", void 0);
__decorate([
    property()
], TypeaheadEditorElement.prototype, "pattern", void 0);
__decorate([
    property()
], TypeaheadEditorElement.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean })
], TypeaheadEditorElement.prototype, "readonly", void 0);
__decorate([
    property({ type: Boolean })
], TypeaheadEditorElement.prototype, "required", void 0);
__decorate([
    property({ type: Boolean })
], TypeaheadEditorElement.prototype, "disabled", void 0);
__decorate([
    property({ attribute: "show-all", type: Boolean })
], TypeaheadEditorElement.prototype, "showAll", void 0);
__decorate([
    property()
], TypeaheadEditorElement.prototype, "name", void 0);
__decorate([
    property({ attribute: "editor-size" })
], TypeaheadEditorElement.prototype, "editorSize", void 0);
__decorate([
    state()
], TypeaheadEditorElement.prototype, "_opened", void 0);
__decorate([
    query("#input")
], TypeaheadEditorElement.prototype, "_inputElement", void 0);
__decorate([
    query("#suggestions")
], TypeaheadEditorElement.prototype, "_suggestionElement", void 0);
TypeaheadEditorElement = __decorate([
    customElement("se-typeahead-inline-editor")
], TypeaheadEditorElement);
export { TypeaheadEditorElement };
//# sourceMappingURL=typeahead-editor.element.js.map